import React from 'react';
import '../styles/Tools.css';

const Tools = () => {
    const tools = [
        {
            id: 1,
            name: 'GeoStudio',
            description: 'Industry-leading software for geotechnical stability analysis. Model slope stability, seepage, deformation, and earthquake effects with precision.',
            icon: '',
            by: 'seequent.com',
            bgColor: '#2241dd'
        },
        {
            id: 2,
            name: 'Plaxis',
            description: 'Advanced finite element analysis for geotechnical engineering. Simulate soil-structure interaction, foundations, tunnels, and excavations.',
            icon: '',
            by: 'bentley.com',
            bgColor: '#2241dd'
        },
        {
            id: 3,
            name: 'RocScience',
            description: 'Comprehensive suite for rock mechanics and geotechnical analysis. Design slopes, tunnels, and foundations in rock with confidence.',
            icon: '',
            by: 'rocscience.com',
            bgColor: '#2241dd'
        },
        {
            id: 4,
            name: 'Settle3',
            description: 'Specialized software for settlement and consolidation analysis. Calculate foundation settlements, time-dependent consolidation, and load distributions.',
            icon: '',
            by: 'rocscience.com',
            bgColor: '#2241dd'
        },
        {
            id: 5,
            name: 'gINT',
            description: 'Professional geotechnical data management and reporting software. Create borehole logs, soil profiles, and geotechnical reports efficiently.',
            icon: '',
            by: 'bentley.com',
            bgColor: '#2241dd'
        },
        {
            id: 6,
            name: 'Slide2',
            description: 'Advanced slope stability analysis software. Evaluate landslide risks, design reinforcements, and analyze seismic effects on slopes.',
            icon: '',
            by: 'rocscience.com',
            bgColor: '#2241dd'
        }
    ];

    return (
        <div className="tools-container">
            <div className="tools-header">
                <h1>Geotechnical Tools</h1>
                <p>Essential software for geotechnical engineering and analysis</p>
            </div>
            <div className="tools-grid">
                {tools.map(tool => (
                    <div key={tool.id} className="tool-card" style={{ '--card-bg': tool.bgColor }}>
                        <div className="tool-icon" style={{ 
                            backgroundColor: tool.bgColor,
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                        </div>
                        <div className="tool-content">
                            <h3>{tool.name}</h3>
                            <p>{tool.description}</p>
                            <small>By {tool.by}</small>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Tools; 